"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("./configuration");
var Validator = (function () {
    function Validator(schema) {
        this.inputRequestDefinition = schema;
    }
    Validator.prototype.validateInputRequest = function (inputJSON, methodName) {
        return this.validateRequest(inputJSON, this.inputRequestDefinition, methodName);
    };
    Validator.prototype.validateRequest = function (inputJSON, requestDefinition, methodName) {
        if (!inputJSON) {
            return;
        }
        if (!requestDefinition) {
            configuration_1.PlanConfiguration.logger.warn("WARNING! No validation schema provided");
            return;
        }
        var validationResult = tv4.validateMultiple(inputJSON, requestDefinition);
        if (!validationResult.valid) {
            this.handleFailedValidation(inputJSON, validationResult, methodName);
        }
        return validationResult;
    };
    Validator.prototype.handleFailedValidation = function (inputJSON, validationResult, methodName) {
    };
    return Validator;
}());
exports.Validator = Validator;
//# sourceMappingURL=validation.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/validation.js
// module id = 83
// module chunks = 0